import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css'; 
import 'slick-carousel/slick/slick-theme.css';

const testimonials = [
  {
    img: 'img/testi1.png',
    text: 'The forced air-warming systems provided by Wallabies Warm Care made my surgery experience comfortable and safe. I was kept warm throughout the procedure, which helped with my recovery.',
    name: 'Dr. Rajesh Kumar',
    hospital: 'Sahara Hospital',
  },
  {
    img: 'img/testi2.png',
    text: 'Wallabies Warm Care’s blankets kept me warm during my procedure. Their attention to patient comfort is unmatched, and I felt well taken care of.',
    name: 'Dr. Suman Agarwal',
    hospital: 'Medcare Hospital',
  },
  {
    img: 'img/testi3.png',
    text: 'I had a great experience using Wallabies Warm Care’s warming systems. They were effective and ensured that I was kept at the right temperature during my surgery.',
    name: 'Dr. Vikram Patel',
    hospital: 'Hope Medical Center',
  },
  {
    img: 'img/testi1.png',
    text: 'I felt a sense of relief knowing that I was being treated with the best warming technology. The systems were efficient and enhanced my comfort during my hospital stay.',
    name: 'Dr. Amit Mehta',
    hospital: 'Healing Hands Hospital',
  },
  {
    img: 'img/testi2.png',
    text: 'Wallabies Warm Care provided excellent warming systems for my surgery. I appreciated their quality and the warmth that kept me safe and comfortable throughout the procedure.',
    name: 'Dr. Neha Sharma',
    hospital: 'Lifeline Care Hospital',
  },
  {
    img: 'img/testi3.png',
    text: 'The forced air-warming blanket I used during my operation made a world of difference. I felt less anxious and more at ease, thanks to their effective heating systems.',
    name: 'Dr. Priya Singh',
    hospital: 'Royal Care Hospital',
  },
];

const Testimonials = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="section testimonials overlay">
      <div className="container">
        <div className="row ">
          <div className="col-lg-12">
            <div className="section-title">
              <h2>What Our Patients Say About Our Wallabies Warm Care</h2>
              <img src="img/section-img2.png" alt="Section Image" />
            </div>
          </div>
        </div>
        <div className="row container">
          <div className="col-lg-12 col-12">
            <Slider {...settings}>
              {testimonials.map((testimonial, index) => (
                <div key={index} className="single-testimonial">
             
                  <p className='text-dark'>{testimonial.text}</p>
                  <h4 className="name darkcolor">{testimonial.name}</h4>
                  <p className="hospital-name">{testimonial.hospital}</p>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
